{
  "welcome_subtitle": "Mes projets en direct",
  "welcome_title": "Bienvenue, {{ name }}",
  "view_project": "Afficher le projet",
  "my_projects": "Mes projets",
  "create_project_form": {
    "title": "Nouveau projet",
    "title_edit": "Modifier le projet",
    "project_name": "Nom du projet",
    "project_expiry_date": "Date d'expiration du projet",
    "project_apps": "Applications et fonctionnalités",
    "billing_provider": "Fournisseur de services de facturation",
    "subscription_plan": "Plan d'abonnement",
    "subscription_plan_price": "Prix",
    "billing_invalid": "Veuillez sélectionner un mode de facturation",
    "plan_invalid": "Veuillez sélectionner un plan",
    "price_invalid": "Veuillez sélectionner un prix",
    "name_invalid": "Entrez un nom.",
    "date_invalid": "Veuillez saisir une date valide postérieure à aujourd'hui.",
    "max_users": "Nombre maximum d'utilisateurs",
    "max_users_invalid": "Le nombre maximum d'utilisateurs doit être supérieur à 0",
    "unlimited_users": "Nombre d'utilisateurs illimité",
    "unlimited": "Illimité"
  },
  "billing_popover": {
    "renew_button": "Renouvelez votre abonnement maintenant",
    "body": "Votre abonnement a expiré. Pour retrouver l'accès à votre projet, renouvelez votre abonnement dès aujourd'hui."
  },
  "service_unavailable": {
    "body": "Ce projet a expiré. Veuillez contacter l'administrateur du projet pour renouveler l'abonnement.",
    "support": "Pour obtenir de l'aide supplémentaire, veuillez"
  }
}